import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', this.handleChange.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('change', this.handleChange.bind(this))
  }

  handleChange(event) {
    const perPage = event.target.value
    const url = new URL(window.location)
    
    // Update or add the per_page parameter
    url.searchParams.set('per_page', perPage)
    
    // Reset to first page when changing per_page
    url.searchParams.delete('page')
    
    // Navigate to the new URL
    window.location.href = url.toString()
  }
}
